module.exports = __webpack_public_path__ + "static/media/260.8ed528df.png";